import { render } from "@/components/pages/dataRecollection/workSupport/dataMonitor/MarkPage.html?vue&type=template&id=1357e948&scoped=true&external"
import script from "@/components/pages/dataRecollection/workSupport/dataMonitor/MarkPage.js?vue&type=script&lang=js&external"
export * from "@/components/pages/dataRecollection/workSupport/dataMonitor/MarkPage.js?vue&type=script&lang=js&external"

import "@/components/pages/dataRecollection/workSupport/dataMonitor/MarkPage.scss?vue&type=style&index=0&id=1357e948&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1357e948"]])

export default __exports__